<!--  -->
<template>
<div :class="isMobile?'mlayout':'layout'">
    <div class='introduce'>
    <span class="close" @click="closeIntro">×</span>
    <p class="title">井冈山革命博物馆简介</p>
    <div class="content">
        <p class="paragraph" v-for="(text,i) in intro" :key="i">{{text}}</p>
    </div>
    
</div>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
    intro:[
        '井冈山革命博物馆是1958年由国家文物局倡议兴建，1959年10月中华人民共和国建国10周年竣工开放的献礼工程，是我国第一个地方性革命史类博物馆，毛泽东主席审阅陈列大纲，朱德委员长题写馆标。全馆收藏文物30000余件，文献资料7000多份，图书7000多册，历史图片10000余张；珍藏党和国家领导人、著名书画家及社会各界知名人士墨宝珍迹数千幅；保存毛泽东、朱德重上井冈山等影视资料片数百件。担负弘扬井冈山精神、宣传井冈山革命斗争历史、保护管理修缮井冈山革命纪念地旧居遗址的光荣职责和神圣使命。先后接待毛泽东、朱德、邓小平、江泽民、胡锦涛、习近平等党和国家领导人及海内外观众5000多万人次。荣获首批全国百个爱国主义教育示范基地、首批国家一级博物馆、中国建设工程鲁班奖（国家优质工程）、新中国成立60周年百项重大经典建设工程、全国博物馆十大陈列展览精品特别奖等荣誉称号。'
    ]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    closeIntro() {
        this.$showIntroduce();
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.layout {
    position:absolute;
    top:0;
    left:0;
    background:rgba(5,47,100,0.5);
    z-index:999;
    .introduce {
        position:absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        width:55vw;
        height:67vh;
       /*  border:2px solid #ff6600;
        border-radius:0.8vw; */
        background:rgba(255,255,255,0.8);
        background:url(../assets/images/tc.png)center no-repeat;
        background-size:100% 100%;
        padding:3vw 2vw;
        .close {
            position:absolute;
            top:-0.5vw;
            right:-1vw;
            width:2vw;
            height:2vw;
            background: #fe761c;
            border-radius:1vw;
            font-size:2vw;
            line-height:1.8vw;
            color:#fff;
            text-align:center;
            cursor:pointer;
        }
        p {
            
            // text-shadow: 0 6px 5px #c4b59d, 0px -2px 1px #fff;
            color: #585755;
            &.title {
                font-size:1.6vw;
                color:#e60012;
                text-align:center;
                font-weight:bold;
                margin-bottom:1vw;
            }
            &.paragraph {
                font-size:1.2vw;
                line-height:2.4vw;
                text-indent:2em;
            }
        }
    }
}
.mlayout {
    position:absolute;
    top:0;
    left:0;
    background:rgba(5,47,100,0.5);
    z-index:999;
    .introduce {
        position:absolute;
        top:10vh;
        left:0;
        right:0;
        margin:auto;
        width:92vw;
        height:67vh;
       /*  border:2px solid #ff6600;
        border-radius:0.8vw; */
        background:rgba(255,255,255,0.8);
        background:url(../assets/images/mobile/tc.png)center no-repeat;
        background-size:100% 100%;
        padding:4vw 2vw;
        .close {
            position:absolute;
            left:0;
            right:0;
            bottom:calc(-10vw + (-22px));
            margin:auto;
            width:10vw;
            height:10vw;
            line-height:9vw;
            border:1px solid #fe761c;
            background:#fff;
            color:#fe761c;
            border-radius:5vw;
            font-size:8vw;            
            
            text-align:center;
            cursor:pointer;
        }
        .content {
            height:calc(100% - 5vw);
            overflow: scroll;
        }
        p {
            font-size:4vw;                                   
            color: #585755;
            &.title {
                font-size:4.8vw;
                color:#e60012;
                text-align:center;
                font-weight:bold;
            }
            &.paragraph {
                text-indent:2em;
                font-size:4vw;
                line-height:6vw;
                padding:0 4vw;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/mixins/introduce.vue